import clsx from 'clsx';
import React from 'react';

import { TextButton } from '@fragment/ui/src/components/Button/TextButton/TextButton';
import { Marker } from '@fragment/ui/src/components/List';

type NavButtonProps = {
  onClick: () => void;
  label: string;
  isActive: boolean;
  testId: string;
} & (
  | {
      marker: 'numeric';
      ordinal: number;
    }
  | {
      marker: 'bullet';
      ordinal?: never;
    }
);

export const NavButton = ({
  onClick,
  marker,
  ordinal,
  label,
  isActive,
  testId,
}: NavButtonProps) => (
  <TextButton onClick={onClick} extraClassNames="w-fit">
    <div
      className="flex flex-row items-center gap-x-f1 group w-fit"
      data-testid={testId}
    >
      <Marker
        type={marker}
        ordinal={ordinal ?? 0}
        color="group-hover:text-main text-main-500"
      />
      <span className={clsx('text-main w-fit', isActive && 'text-main-500')}>
        {label}
      </span>
    </div>
  </TextButton>
);
